import colors from "@digits-shared/themes/colors"
import styled from "styled-components"

export const ApplicationTopSection = styled.header`
  margin-top: 24px;
  color: var(--header-text-color, ${colors.white});
  background: var(--header-background-image, none) var(--header-background-color, ${colors.teal});

  width: max(100%, var(--application-pane-full-width));
  padding: 16px 16px 8px;
  border-radius: 16px 16px 0 0;

  display: flex;
  flex-direction: column;
  gap: 16px;
`
